import React, { CSSProperties, JSX } from "react";
import { createPortal } from "react-dom";
import { Tooltip } from "react-tooltip";
import styles from "./Tooltip.module.scss";

interface IMyTooltipProps extends Omit<React.ComponentProps<typeof Tooltip>, "anchorSelect"> {
	element: JSX.Element;
	elementStyle?: CSSProperties;
	renderElementChildren?: boolean;
	id: string;
	popup?: React.ReactNode;
	popupStyle?: CSSProperties;
}

export const MyTooltip: React.FC<IMyTooltipProps> = ({ element, elementStyle, popup, popupStyle, id, ...rest }) => {
	const idWithSuffix = id + "-tooltip";

	const elementWithId = React.cloneElement(element, {
		id: idWithSuffix,
		style: elementStyle,
	});

	// Add later if needed
	// let elem = element;
	// if (renderElementChildren) {
	// 	elem = elem.props.children;
	// }

	return (
		<>
			{elementWithId}
			{createPortal(
				<Tooltip
					className={styles.main}
					style={popupStyle}
					opacity={1}
					positionStrategy="fixed"
					{...rest}
					anchorSelect={`#${idWithSuffix}`}>
					{popup}
				</Tooltip>,
				document.body,
			)}
		</>
	);
};
